module.exports = __webpack_public_path__ + "img/kitchen2.63c4c20b.jpg";